export default __webpack_public_path__ + "static/media/postgre.a7fa3991.png";